export const getHoverColor = (x) => getPastelColor(x, 'd9');
export const getPastelColor = (x, alphaHex) => /^#.{6}$/.test(x?.toString() ?? '') ? `${x}${alphaHex ?? '2a'}` : x;
export function getLuminance(hex) {
    const isShorthand = hex.length === 4;
    const hexLong = isShorthand
        ? '#' +
            hex
                .slice(1, 4)
                .split('')
                .map(char => char + char)
                .join('')
        : hex;
    const r = parseInt(hexLong.slice(1, 3), 16) / 255;
    const g = parseInt(hexLong.slice(3, 5), 16) / 255;
    const b = parseInt(hexLong.slice(5, 7), 16) / 255;
    const a = [r, g, b].map(c => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4)));
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}
export function getContrastRatio(hexColor1, hexColor2) {
    const lum1 = getLuminance(hexColor1);
    const lum2 = getLuminance(hexColor2);
    const brightest = Math.max(lum1, lum2);
    const darkest = Math.min(lum1, lum2);
    return (brightest + 0.05) / (darkest + 0.05);
}
export function isWhite(hexColor) {
    return !!hexColor && ['#ffffff', '#fff', 'white'].includes(hexColor.toLowerCase());
}
export function isHexCode(hexColor) {
    return typeof hexColor === 'string' && hexColor.startsWith('#');
}
export function isLightBackground(hexColor) {
    if (!hexColor)
        return false;
    if (hexColor === 'white')
        return true;
    if (isHexCode(hexColor)) {
        const luminance = getLuminance(hexColor);
        return luminance > 0.5;
    }
    return false;
}
export const hexToRgba = (hex, opacityPct = 100) => {
    const clean = hex.replace('#', '');
    const normalized = clean.length === 3
        ? clean
            .split('')
            .map(char => `${char}${char}`)
            .join('')
        : clean;
    const r = parseInt(normalized.substring(0, 2), 16) || 0;
    const g = parseInt(normalized.substring(2, 4), 16) || 0;
    const b = parseInt(normalized.substring(4, 6), 16) || 0;
    return `rgba(${r}, ${g}, ${b}, ${Math.min(Math.max(opacityPct, 0), 100) / 100})`;
};
//# sourceMappingURL=color.js.map